import { handleRequest } from "../utilities/requestHandler";

export const createSchedulerJob = (req_body) => 
    handleRequest("post", "/scheduler/create", req_body);

export const getAllSchedulerJobs = () => 
    handleRequest("get", "/scheduler/get_all_jobs");

/**
 * Manually trigger cleanup of recently viewed documents
 */
export const triggerRecentlyViewedCleanup = () => 
    handleRequest("post", "/scheduler/recently-viewed/trigger");

/**
 * Get statistics about recently viewed documents
 */
export const getRecentlyViewedCleanupStats = () => 
    handleRequest("get", "/scheduler/recently-viewed/stats");

/**
 * Get current cleanup days configuration
 */
export const getCleanupDaysConfig = () => 
    handleRequest("get", "/scheduler/recently-viewed/config");

/**
 * Update cleanup days configuration
 * @param {number} days - Number of days after which to cleanup records
 */
export const updateCleanupDaysConfig = (days) => 
    handleRequest("put", "/scheduler/recently-viewed/config", { cleanup_days: days });